export default __webpack_public_path__ + "static/ceinture.range-14c5ce0510c4a7f37494746a1ef1fb62.jpg";